import { BrowserRouter, Switch, Route, Redirect, useHistory } from "react-router-dom";

import PageHome from "containers/PageHome/PageHome";
import Page404 from "containers/Page404/Page404";
import AccountPage from "containers/AccountPage/AccountPage";
import PageSignUp from "containers/PageSignUp/PageSignUp";
import PageLogin from "containers/PageLogin/PageLogin";
import SiteHeader from "containers/SiteHeader";
import PageSearch from "containers/PageSearch";
import ProductDetailPage from "containers/ProductDetailPage/ProductDetailPage";
import AccountSavelists from "containers/AccountPage/AccountSavelists";
import AccountPass from "containers/AccountPage/AccountPass";
import AccountOrder from "containers/AccountPage/AccountOrder";
import CartPage from "containers/ProductDetailPage/CartPage";
import CheckoutInformationPage from "containers/PageCheckout/CheckoutInformationPage";
import PageCollection2 from "containers/PageCollection";
import PageForgotPswd from "containers/PageForgotPswd/PageForgotPswd";
import ShippingAddress from "containers/PageCheckout/ShippingAddress";
import AddShippingAddress from "containers/PageCheckout/AddShippingAddress";
import EditShippingAddress from "containers/PageCheckout/EditShippingAddress";
import CheckoutDelivery from "containers/PageCheckout/CheckoutDelivery";
import CheckoutPayment from "containers/PageCheckout/CheckoutPayment";
import Footer from "shared/Footer/Footer";
import OnChangeRoute from "./OnChangeRoute";
import { Page } from "./types";
import ProductCategory from "containers/ProductCategory";
import Contact from "containers/PageContact/Contact";
import Cgv from "containers/PageCGV/Cgv";
import MentionsLegales from "containers/PageMentionsLegales/MentionsLegales";
import { useEffect } from "react";
import Overview from "containers/Customer/Overview";
import NosAlcoolsBioFrançais from "containers/Pages/NosAlcoolsBioFrançais";
import ConfirmPayment from "containers/PageCheckout/ConfirmPayment";

export const auth = (Component: any) => {
  return (props: any) => {
    const refreshToken = localStorage.getItem("token");
    const history = useHistory();

    useEffect(() => {
      if (!refreshToken) {
        history.push("/login");
      }
    }, [refreshToken, history]);

    return refreshToken ? <Component {...props} /> : <Redirect to="/login" />;
  };
};

export const notAuth = (Component: any) => {
  return (props: any) => {
    const refreshToken = localStorage.getItem("token");
    const history = useHistory();

    useEffect(() => {
      if (refreshToken) {
        history.push("/");
      }
    }, [refreshToken, history]);

    return refreshToken ? <Redirect to="/" /> : <Component {...props} />;
  };
};

export const pages: Page[] = [
  { path: "/", exact: true, component: PageHome },
  { path: "/#", exact: true, component: PageHome },
  //
  { path: "/home-header-2", exact: true, component: PageHome },

  { path: "/product-detail/:slug", component: ProductDetailPage },

  { path: "/customer/overview", component: Overview },

  // CONTACT
  { path: "/contact", component: Contact },


  // CGV
  { path: "/cgv", component: Cgv },
  { path: "/mentions-legales", component: MentionsLegales },


  { path: "/page/nos-alcools-bio-français", component: NosAlcoolsBioFrançais },


  //
  { path: "/page-collection", component: PageCollection2 },
  { path: "/search", component: PageSearch },
  { path: "/products/", component: ProductCategory },
  //
  { path: "/account", component: auth(AccountPage) },
  { path: "/account-savelists", component: auth(AccountSavelists) },
  { path: "/account-change-password", component: auth(AccountPass) },
  { path: "/shipping-address", component: auth(ShippingAddress) },
  { path: "/add-shipping-address", component: auth(AddShippingAddress) },
  { path: "/edit-shipping-address/:id", component: auth(EditShippingAddress) },
  { path: "/account-my-order", component: auth(AccountOrder) },
  //
  { path: "/cart", component: CartPage },
  { path: "/checkout/information", component: CheckoutInformationPage },
  { path: "/checkout/delivery", component: CheckoutDelivery },
  { path: "/checkout/payment", component: CheckoutPayment },
  { path: "/checkout/confirm", component: ConfirmPayment },
  //
  { path: "/signup", component: notAuth(PageSignUp) },
  { path: "/login", component: notAuth(PageLogin) },
  { path: "/forgot-pass/:id", component: PageForgotPswd },
  { path: "/forgot-pass", component: PageForgotPswd },



  // REDIRECT
  { path: "/connexion", component: () => <Redirect to="/login" /> },
  { path: "/panier", component: () => <Redirect to="/cart" /> },
  { path: "/r/cognac-loriot-bio", component: () => <Redirect to="/product-detail/vivant-cognac-loriot-bio" /> },
  { path: "/r/cognac-loriot-bio-1", component: () => <Redirect to="/product-detail/vivant-cognac-loriot-bio" /> },
  { path: "/r/rhum-triton-bio", component: () => <Redirect to="/product-detail/rhum-triton-ambre-bio-vivant" /> },
  { path: "/r/gin-decroix-bio", component: () => <Redirect to="/product-detail/vivant-gin-decroix-bio" /> },
  { path: "/r/gin-iris-bio-1", component: () => <Redirect to="/product-detail/vivant-gin-iris-bio" /> },
  { path: "/r/rhum-ambre-gino-bio", component: () => <Redirect to="/product-detail/vivant-rhum-gino-bio" /> },
  { path: "/r/gin-machaon-bio-1", component: () => <Redirect to="/product-detail/vivant-gin-machaon-bio" /> },
  { path: "/resetting/request", component: () => <Redirect to="/forgot-pass" /> },
  { path: "/r/whisky-goupil-single-malt-bio", component: () => <Redirect to="/product-detail/vivant-whisky-goupil-bio" /> },
  { path: "/r/rhum-dore-lola-bio-1", component: () => <Redirect to="/product-detail/vivant-rhum-lola-bio" /> },
  { path: "/r/pur-malt-ange-bio-1", component: () => <Redirect to="/product-detail/vivant-pur-malt-ange-bio" /> },
  { path: "/r/cognac-decroix-bio-xo-50cl", component: () => <Redirect to="/product-detail/vivant-cognac-decroix-xo-bio-50cl" /> },
  { path: "/r/cognac-decroix-bio-xo-20cl", component: () => <Redirect to="/product-detail/vivant-cognac-decroix-xo-bio-20cl" /> },
  { path: "/cat/produits/boutique", component: () => <Redirect to="/products" /> },
  { path: "/page/mentions-legales", component: () => <Redirect to="/mentions-legales" /> },
  { path: "/r/cognac-decroix-bio-vsop-70cl-1", component: () => <Redirect to="/product-detail/vivant-cognac-decroix-vsop-bio" /> },
  { path: "/r/cognac-decroix-bio-xo-70cl-1", component: () => <Redirect to="/product-detail/vivant-cognac-decroix-xo-bio-70cl" /> },
  { path: "/r/whisky-silene-single-malt-francais-bio", component: () => <Redirect to="/product-detail/vivant-whisky-silene-bio" /> },
  { path: "/r/whisky-goupil-single-malt-bio-1", component: () => <Redirect to="/product-detail/vivant-whisky-goupil-bio" /> },

  { path: "/cat/produits/portraits-vivant", component: () => <Redirect to="/products?categories=Gamme%20:%20Portraits%20Vivant" /> },
  { path: "/cat/produits/gin-decroix", component: () => <Redirect to="/products" /> },
  { path: "/cat/produits/cognac-biologique", component: () => <Redirect to="/products?categories=Cognac%20biologique" /> },

];

const Routes = () => {
  return (
    <BrowserRouter basename="/">
      <OnChangeRoute />
      <SiteHeader />
      <Switch>
        {pages.map(({ component, path, exact }) => {
          return (
            <Route
              key={path}
              component={component}
              exact={!!exact}
              path={path}

            />
          );
        })}
        <Route component={Page404} />
      </Switch>
      <Footer />
    </BrowserRouter>
  );
};

export default Routes;
